var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDaphneHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29413",
    "data-name": "Group 29413",
    transform: "translate(-288 -422.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(288 422.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29403",
    "data-name": "Group 29403",
    transform: "translate(305 428.379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50261",
    "data-name": "Path 50261",
    d: "M34.8,14a21.015,21.015,0,0,0,.68,3.544,3.669,3.669,0,0,1-.68,3.714c-1.559,1.641,2.275,3.558-.766,5.84C31.745,28.821,28,26.7,28,26.7V22.619Z",
    transform: "translate(-16.206 -7.674)",
    fill: "#f57c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50262",
    "data-name": "Path 50262",
    d: "M24.174,33.589H19.638l-.3-6.153,4.836.709Z",
    transform: "translate(-11.473 -15.015)",
    fill: "#efad60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50263",
    "data-name": "Path 50263",
    d: "M19,17.258s1.158,4.5,4.333,4.5c1.245.01,1.915-1.148,2.924-2.227.678-.725,1.323-1.221,1.506-1.95.454-1.814.309-2.587,1.216-3.947S22.629,10,22.629,10L19,12.268Z",
    transform: "translate(-11.289 -5.488)",
    fill: "#ffcc80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50264",
    "data-name": "Path 50264",
    d: "M25.514,19.776a1.662,1.662,0,0,0-2.259-1.462C23.255,20.581,25.514,19.776,25.514,19.776Z",
    transform: "translate(-13.613 -9.989)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50265",
    "data-name": "Path 50265",
    d: "M30.467,19.777a2.094,2.094,0,0,0-.232,2.128c.173.477-.212.657-.847.738-.411.053-.387.467-.1.5.3.051,1.687-.152,1.444-1.249C30.547,21.076,30.163,20.718,30.467,19.777Z",
    transform: "translate(-16.794 -10.83)",
    fill: "#efad60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50266",
    "data-name": "Path 50266",
    d: "M33,20.945s.487-1.4,2.427-.661A1.409,1.409,0,0,1,33,20.945Z",
    transform: "translate(-18.938 -10.989)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50267",
    "data-name": "Path 50267",
    d: "M26.362,29.669l1.175-.222a.525.525,0,0,0,.753.087l.794.589a1.987,1.987,0,0,1-1.361.454A1.678,1.678,0,0,1,26.362,29.669Z",
    transform: "translate(-15.311 -16.114)",
    fill: "#e57373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50268",
    "data-name": "Path 50268",
    d: "M16.966,42.128a7.3,7.3,0,0,0,7.711-.454V38.953a18.824,18.824,0,0,1-5.443,0C16.512,38.5,16.966,42.128,16.966,42.128Z",
    transform: "translate(-10.162 -21.286)",
    fill: "#7cb342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50269",
    "data-name": "Path 50269",
    d: "M31.316,38.844a16.781,16.781,0,0,1,2.085,3.79H28.907l-.234-3.117c-.034-.488-.591-.713-1.5-.76l.675-.405C28.395,38.022,30.771,38.155,31.316,38.844Z",
    transform: "translate(-15.753 -20.884)",
    fill: "#9ccc65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50270",
    "data-name": "Path 50270",
    d: "M20.145,4.566a1.965,1.965,0,0,1,.907,1.814c0,1.361-1.389,2.58-4.111,2.127s-5.2-3.046-5.2-3.046S11.526,8.195,10.165,9.1c-.454,2.268.265,3.947,1.172,5.762a4.7,4.7,0,0,1-.8,5.668c-1.76,1.694-7.57,2.32-8.534-2.357.864.989,2.665-.255,1.758-1.616S2,12.731,5.175,10.009C5.851,5.743,7.6,1.5,12,.3,15.943-.772,20.145,1.844,20.145,4.566Z",
    transform: "translate(-2 -0.054)",
    fill: "#f57c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50271",
    "data-name": "Path 50271",
    d: "M19.361,7.536a5.558,5.558,0,0,1,4.99-2.722,6.564,6.564,0,0,1,5.233,2.169l-.7-1.716A5.346,5.346,0,0,0,24.351,3C21.175,3,18.454,6.175,18,8.443A3.951,3.951,0,0,1,19.361,7.536Z",
    transform: "translate(-10.742 -1.664)",
    fill: "#b388ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50272",
    "data-name": "Path 50272",
    d: "M23.255,18.316a1.739,1.739,0,0,0,.342,1.16.743.743,0,0,0,.751-1.175A2.309,2.309,0,0,0,23.255,18.316Z",
    transform: "translate(-13.613 -9.992)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50273",
    "data-name": "Path 50273",
    d: "M33.054,20.951a.7.7,0,0,0,.044.122,1.434,1.434,0,0,0,.756.371.678.678,0,0,0,.175-1.262A1.422,1.422,0,0,0,33.054,20.951Z",
    transform: "translate(-18.967 -11.052)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50274",
    "data-name": "Path 50274",
    d: "M22.952,16.032c1.76-.7,1.737.565,2.714.869C24.472,17.227,24.733,15.815,22.952,16.032Z",
    transform: "translate(-13.448 -8.671)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50275",
    "data-name": "Path 50275",
    d: "M16.119,11.191s-.035,1.424-2.849,2.78c-1.652.8-2.154,2.606-2.328,4-.1-3.2,1.216-4.169,2.154-4.656S15.667,11.956,16.119,11.191Z",
    transform: "translate(-6.883 -6.139)",
    fill: "#ef6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50276",
    "data-name": "Path 50276",
    d: "M18.615,11.973a6.351,6.351,0,0,1-2.389,3.67,4.814,4.814,0,0,0-1.593,4.4s.232-2.548,1.708-3.677A5.406,5.406,0,0,0,18.615,11.973Z",
    transform: "translate(-8.872 -6.567)",
    fill: "#ef6c00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaphneHighlighted);
export default __webpack_public_path__ + "static/media/daphneHighlighted.6d79743e836078ef3a1bbe399165babe.svg";
export { ForwardRef as ReactComponent };